import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  filterContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  filterHeaderContainer: {
    position: 'relative',
    mb: '16px'
  },
  filterHeader: {
    textAlign: 'center'
  },
  backButton: {
    background: 'none',
    border: 'none',
    zIndex: theme.zIndex.documentUp,
    display: 'inline-block',
    top: ['20px', '40px', '40px', '40px', '40px', '40px'],
    left: ['24px', '38px', '38px', '38px', '38px', '38px'],
    position: 'absolute'
  },
  filler: {
    flex: 1
  },
  filterLinkList: isHidden => ({
    listStyleType: 'none',
    display: isHidden ? 'block' : 'none',
    li: {
      display: 'inline-flex',
      lineHeight: '19px',
      width: '100%',
      flexDirection: 'row',
      my: '14px',
      letterSpacing: '.05rem',
      justifyContent: 'space-between'
    }
  }),
  filterLinkButton: {
    '.button-children-wrapper': {
      width: '100%',
      fontWeight: 100,
      justifyContent: 'space-between'
    }
  },
  headerContainer: {
    flexShrink: 0,
    padding: ['16px', '38px 40px'],
    '.headings::first-letter': {
      textTransform: 'uppercase'
    }
  },
  filterContent: isHidden => ({
    overflow: 'auto',
    p: isHidden ? '0 30px 30px 30px' : 'auto',
    ...reusables.scrollbar()
  }),
  filterButtons: {
    padding: ['16px', '38px 40px']
  }
};